import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateReadingTime(textOrPost: string | { readingMinutes?: number; content?: string; excerpt?: string }): string {
  if (!textOrPost) return '1 MIN READ';
  if (typeof textOrPost === 'object') {
    if (typeof textOrPost.readingMinutes === 'number') {
      return `${textOrPost.readingMinutes} MIN READ`;
    }
    const text = textOrPost.content || textOrPost.excerpt || '';
    const plainText = text.replace(/<[^>]*>?/gm, '');
    const wordCount = plainText.trim().split(/\s+/).filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(wordCount / 200));
    return `${minutes} MIN READ`;
  }
  const text = typeof textOrPost === 'string' ? textOrPost : '';
  const plainText = text.replace(/<[^>]*>?/gm, '');
  const wordCount = plainText.trim().split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(wordCount / 200));
  return `${minutes} MIN READ`;
}

export function cleanBlogDescription(text: string): string {
  if (!text) return '';
  const plain = text.replace(/<[^>]*>?/gm, '').trim();
  if (plain.length <= 160) return plain;
  const sub = plain.substring(0, 155);
  const lastPeriod = sub.lastIndexOf('.');
  const lastExcl = sub.lastIndexOf('!');
  const lastQ = sub.lastIndexOf('?');
  const bestSentenceEnd = Math.max(lastPeriod, lastExcl, lastQ);
  if (bestSentenceEnd > 40) {
    return plain.substring(0, bestSentenceEnd + 1).trim();
  }
  const lastSpace = sub.lastIndexOf(' ');
  if (lastSpace > 20) {
    return plain.substring(0, lastSpace).trim();
  }
  return sub.trim();
}

export function rewriteLegacyLinks(html: string): string {
  if (!html) return '';
  return html
    .replace(/https?:\/\/(www\.)?fivelensenneagram\.co\.za\/five-lens-certification-courses\/?/gi, '/practitioner-certification')
    .replace(/https?:\/\/(www\.)?fivelensenneagram\.co\.za\/solutions\/?/gi, '/organizations')
    .replace(/\/five-lens-certification-courses\/?/gi, '/practitioner-certification')
    .replace(/\/solutions\/?/gi, '/organizations')
    .replace(/https?:\/\/(www\.)?fivelensenneagram\.co\.za(\/[^"'\s]*)?/gi, (_match, _www, path) => {
      const p = (path || '/').toLowerCase().replace(/\/+$/, '');
      if (p === '/five-lens-certification-courses' || p === '/five-lens-certification-courses/') return '/practitioner-certification';
      if (p === '/solutions' || p === '/solutions/') return '/organizations';
      if (p === '/about-us' || p === '/about') return '/about';
      if (p === '/contact-us' || p === '/contact') return '/contact';
      if (p === '/the-five-lenses' || p === '/framework') return '/framework';
      if (p === '/for-organisations' || p === '/organizations') return '/organizations';
      if (p === '/practitioners') return '/practitioners';
      if (p === '/blog') return '/blog';
      return '/';
    });
}

